import { render, staticRenderFns } from "./RelAccount.vue?vue&type=template&id=8cf4ce90&scoped=true"
import script from "./RelAccount.vue?vue&type=script&lang=js"
export * from "./RelAccount.vue?vue&type=script&lang=js"
import style0 from "./RelAccount.vue?vue&type=style&index=0&id=8cf4ce90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf4ce90",
  null
  
)

export default component.exports